module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal.8fec5542.png";